import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { RiHome5Line, RiAtFill, RiAddCircleLine, RiCarLine, RiLogoutBoxLine, RiShieldUserLine } from "react-icons/ri";
import { useAuth } from '../context/AuthContext';

export default function NavigationMenu( {setShowMenu} ) {
  const navigate = useNavigate();
  const { user, role, logout } = useAuth();
  const buttonStyle = { textAlign: 'left' };

  const handleNavigate = (navigateTo) => {
    if (setShowMenu) { setShowMenu(false) }
    navigate(navigateTo)
  };

  const handleLogout = () => {
    if (setShowMenu) { setShowMenu(false) }
    logout();
  };

  return (
    <>
      <ButtonGroup vertical style={{ width: '100%' }} className="shadow p-2 mb-5 bg-white card-navigation-menu">
        <Button variant="outline-primary" style={buttonStyle} onClick={() => handleNavigate('/')}>
          <RiHome5Line className='icon' /><div>Inicio</div>
        </Button>
        <Button variant="outline-primary" style={buttonStyle} onClick={() => handleNavigate('/acerca')}>
          <RiAtFill className='icon' /><div>Quienes somos</div>
        </Button>
        <Button variant="primary" style={buttonStyle} onClick={() => handleNavigate('/publicar')}>
          <RiAddCircleLine className='icon' /><div>Publicar mi auto gratis</div>
        </Button>
        {user && (
          <>
            <Button variant="outline-primary" style={buttonStyle} onClick={() => handleNavigate('/mis-publicaciones')}>
              <RiCarLine className='icon' /><div>Mis publicaciones</div>
            </Button>
            {(role === 'ADMIN' || role === 'REVIEWER') && (
              <Button variant="outline-primary" style={buttonStyle} onClick={() => handleNavigate('/admin')}>
                <RiShieldUserLine className='icon' /><div>Panel admin</div>
              </Button>
            )}
            <Button variant="outline-danger" style={buttonStyle} onClick={handleLogout}>
              <RiLogoutBoxLine className='icon' /><div>Cerrar sesión</div>
            </Button>
          </>
        )}
      </ButtonGroup>
    </>
  )
};